/* Avanti locations: open/closed status (America/Toronto), slide-out panel, locations page map + distance sort. */
(function () {
 if (window.AvantiLocations) return;

 var TZ = 'America/Toronto';
 var LANG = (document.documentElement.getAttribute('lang') || 'en').toLowerCase().indexOf('fr') === 0 ? 'fr' : 'en';
 var WEEKDAY_INDEX = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
 var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

 function nowInToronto() {
  try {
   var parts = {};
   new Intl.DateTimeFormat('en-US', { timeZone: TZ, weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
    .formatToParts(new Date())
    .forEach(function (p) { parts[p.type] = p.value; });
   var h = parseInt(parts.hour, 10) % 24;
   return { day: WEEKDAY_INDEX[parts.weekday], min: h * 60 + parseInt(parts.minute, 10) };
  } catch (e) {
   var d = new Date();
   return { day: (d.getDay() + 6) % 7, min: d.getHours() * 60 + d.getMinutes() };
  }
 }

 function parseRange(s) {
  var m = /(\d{1,2})(?:[:h](\d{2}))?\s*[-–—]\s*(\d{1,2})(?:[:h](\d{2}))?/.exec(s || '');
  if (!m) return null;
  return [parseInt(m[1], 10) * 60 + parseInt(m[2] || '0', 10), parseInt(m[3], 10) * 60 + parseInt(m[4] || '0', 10)];
 }

 function pad(n) { return (n < 10 ? '0' : '') + n; }

 function fmtTime(min) {
  var h = Math.floor(min / 60), m = min % 60;
  if (LANG === 'fr') return h + ' h' + (m ? ' ' + pad(m) : '');
  var h12 = h % 12 || 12;
  return h12 + (m ? ':' + pad(m) : '') + ' ' + (h >= 12 && h < 24 ? 'pm' : 'am');
 }

 function fmtRange(r) { return fmtTime(r[0]) + ' – ' + fmtTime(r[1]); }

 function dayName(i) {
  var d = new Date(Date.UTC(2024, 0, 1 + i, 12)); /* 2024-01-01 is a Monday */
  try {
   return new Intl.DateTimeFormat(LANG === 'fr' ? 'fr-CA' : 'en-CA', { weekday: 'long', timeZone: 'UTC' }).format(d);
  } catch (e) {
   return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'][i];
  }
 }

 function i18nFor(el) {
  var host = el.closest('[data-avlx-i18n]');
  if (!host) return {};
  if (!host._avlxI18n) {
   try { host._avlxI18n = JSON.parse(host.getAttribute('data-avlx-i18n')) || {}; } catch (e) { host._avlxI18n = {}; }
  }
  return host._avlxI18n;
 }

 function computeStatus(hours, t) {
  var now = nowInToronto();
  var today = parseRange(hours[now.day]);
  if (today && now.min >= today[0] && now.min < today[1]) {
   return { open: true, text: fmtRange(today), today: now.day };
  }
  if (today && now.min < today[0]) {
   return { open: false, text: (t.opens_at || 'Opens at') + ' ' + fmtTime(today[0]), today: now.day };
  }
  for (var k = 1; k <= 7; k++) {
   var d = (now.day + k) % 7, r = parseRange(hours[d]);
   if (r) {
    var tpl = t.opens_day || 'Opens {day} at';
    return { open: false, text: tpl.replace('{day}', dayName(d)) + ' ' + fmtTime(r[0]), today: now.day };
   }
  }
  return { open: false, text: '', today: now.day };
 }

 function renderHours(el) {
  var hours;
  try { hours = JSON.parse(el.getAttribute('data-avlx-hours')) || []; } catch (e) { return; }
  var t = i18nFor(el);
  var st = computeStatus(hours, t);
  var status = el.querySelector('.avlx-status');
  if (status) {
   status.classList.toggle('is-open', st.open);
   status.innerHTML = '';
   var dot = document.createElement('span'); dot.className = 'avlx-status__dot'; dot.setAttribute('aria-hidden', 'true');
   var label = document.createElement('span'); label.className = 'avlx-status__label';
   label.textContent = st.open ? (t.open_now || 'Open now') : (t.closed_now || 'Closed now');
   status.appendChild(dot); status.appendChild(label);
   if (st.text) {
    var sep = document.createElement('span'); sep.setAttribute('aria-hidden', 'true'); sep.textContent = '·';
    var txt = document.createElement('span'); txt.textContent = st.text;
    status.appendChild(sep); status.appendChild(txt);
   }
   status.hidden = false;
  }
  var dl = el.querySelector('.avlx-week dl');
  if (dl) {
   dl.innerHTML = '';
   for (var i = 0; i < 7; i++) {
    var r = parseRange(hours[i]);
    var dt = document.createElement('dt'); dt.textContent = dayName(i);
    var dd = document.createElement('dd'); dd.textContent = r ? fmtRange(r) : (t.closed || 'Closed');
    if (i === st.today) { dt.className = 'is-today'; dd.className = 'is-today'; }
    dl.appendChild(dt); dl.appendChild(dd);
   }
   var week = el.querySelector('.avlx-week');
   if (week) week.hidden = false;
  }
 }

 function renderAll(scope) {
  var els = (scope || document).querySelectorAll('[data-avlx-hours]');
  for (var i = 0; i < els.length; i++) renderHours(els[i]);
 }

 /* ---------------- Slide-out panel ---------------- */
 var drawer = document.getElementById('AvldDrawer');
 var panel = drawer ? drawer.querySelector('.avld__panel') : null;
 var lastFocus = null, closeTimer = null, isOpen = false;
 var hosts = [location.host.toLowerCase()];
 if (drawer && drawer.getAttribute('data-hosts')) {
  hosts = hosts.concat(drawer.getAttribute('data-hosts').split(',').map(function (h) { return h.trim().toLowerCase(); }));
 }

 function isLocationsLink(a) {
  var href = a.getAttribute('href');
  if (!href || href.charAt(0) === '#') return false;
  var u;
  try { u = new URL(href, location.href); } catch (e) { return false; }
  if (hosts.indexOf(u.host.toLowerCase()) === -1) return false;
  if (u.hash) return false;
  return /^\/(?:fr\/)?pages\/montreal-locations\/?$/i.test(u.pathname);
 }

 function focusables() {
  var list = panel.querySelectorAll('a[href], button:not([disabled]), summary, input, select, textarea, [tabindex]:not([tabindex="-1"])');
  return Array.prototype.filter.call(list, function (n) { return n.getClientRects().length > 0; });
 }

 function onKey(e) {
  if (!isOpen) return;
  if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeDrawer(); return; }
  if (e.key !== 'Tab') return;
  var f = focusables();
  if (!f.length) { e.preventDefault(); panel.focus(); return; }
  var first = f[0], last = f[f.length - 1];
  if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
 }

 function lockScroll() {
  var sbw = window.innerWidth - document.documentElement.clientWidth;
  if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
  document.documentElement.classList.add('avld-lock');
 }

 function unlockScroll() {
  document.documentElement.classList.remove('avld-lock');
  document.body.style.paddingRight = '';
 }

 function closeThemeMobileNav() {
  var b = document.body, h = document.documentElement;
  var open = /(^|\s)(reveal-mobile-nav|mobile-nav-open|mobile-nav--open|nav-open)(\s|$)/;
  if (!open.test(b.className) && !open.test(h.className)) return;
  var t = document.querySelector('.mobile-navigation-drawer .mobile-nav-toggle') || document.querySelector('.header-shade.mobile-nav-toggle');
  if (t) { try { t.click(); } catch (e) {} }
 }

 function openDrawer(trigger) {
  if (!drawer || isOpen) return;
  clearTimeout(closeTimer);
  closeThemeMobileNav();
  lastFocus = trigger || document.activeElement;
  renderAll(drawer);
  drawer.hidden = false;
  drawer.setAttribute('aria-hidden', 'false');
  void drawer.offsetWidth;
  drawer.classList.add('is-open');
  isOpen = true;
  lockScroll();
  document.addEventListener('keydown', onKey);
  var closeBtn = drawer.querySelector('.avld__close');
  setTimeout(function () {
   try { (closeBtn || panel).focus({ preventScroll: true }); } catch (e) { (closeBtn || panel).focus(); }
  }, reduceMotion ? 0 : 60);
 }

 function closeDrawer(noFocus) {
  if (!drawer || !isOpen) return;
  isOpen = false;
  drawer.classList.remove('is-open');
  document.removeEventListener('keydown', onKey);
  unlockScroll();
  closeTimer = setTimeout(function () {
   drawer.hidden = true;
   drawer.setAttribute('aria-hidden', 'true');
  }, reduceMotion ? 0 : 380);
  if (!noFocus && lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
   try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); }
  }
 }

 if (drawer && panel) {
  /* Opens the panel from header, menu and announcement bar links to the Locations page. Links inside the panel are never intercepted. */
  document.addEventListener('click', function (e) {
   if (e.defaultPrevented || (e.button && e.button !== 0) || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
   var el = e.target && e.target.nodeType === 1 ? e.target : (e.target && e.target.parentElement);
   if (!el || !el.closest) return;
   if (drawer.contains(el)) return;
   var a = el.closest('a[href]');
   if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
   /* Footer links and links marked data-avl-native go to the Locations page itself. */
   if (a.closest('[data-avl-native], #pagefooter, footer, .section-footer, [data-section-type="footer"]')) return;
   if (!isLocationsLink(a)) return;
   e.preventDefault();
   openDrawer(a);
  });

  drawer.addEventListener('click', function (e) {
   var el = e.target && e.target.nodeType === 1 ? e.target : (e.target && e.target.parentElement);
   if (!el) return;
   if (el.closest('[data-avld-close]')) { e.preventDefault(); closeDrawer(); return; }
   var a = el.closest('a[href]');
   if (a && isOpen && a.target !== '_blank' && !/^(tel|mailto|sms):/i.test(a.getAttribute('href') || '')) closeDrawer(true);
  });

  var accBtns = drawer.querySelectorAll('[data-avld-toggle]');
  Array.prototype.forEach.call(accBtns, function (btn) {
   btn.addEventListener('click', function () {
    var region = document.getElementById(btn.getAttribute('aria-controls'));
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    if (region) region.hidden = expanded;
   });
  });

  window.addEventListener('pageshow', function (e) {
   if (e.persisted && isOpen) closeDrawer(true);
  });

  document.addEventListener('shopify:section:select', function (e) {
   if (e.target && e.target.contains(drawer)) openDrawer();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
   if (e.target && e.target.contains(drawer)) closeDrawer();
  });
 }

 /* ---------------- Locations page ---------------- */
 function haversineKm(lat1, lon1, lat2, lon2) {
  var R = 6371, toRad = Math.PI / 180;
  var dLat = (lat2 - lat1) * toRad, dLon = (lon2 - lon1) * toRad;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
 }

 function mapSrc(q) {
  return 'https://maps.google.com/maps?q=' + encodeURIComponent(q) + '&z=15&output=embed';
 }
 /* Replaces the map iframe with a fresh one: loads at once, no lazy loading, no history entry. */
 function selectCard(root, card, scroll) {
  if (!root || !card) return;
  var t = i18nFor(root);
  var cards = root.querySelectorAll('.avlp-card');
  Array.prototype.forEach.call(cards, function (c) {
   var on = c === card;
   c.classList.toggle('is-active', on);
   if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
  });
  var iframe = root.querySelector('.avlp__map iframe');
  var q = card.getAttribute('data-map');
  if (iframe && q) {
   var src = mapSrc(q);
   if (iframe.getAttribute('data-avlp-q') !== q) {
    var fresh = iframe.cloneNode(false);
    fresh.removeAttribute('loading');
    fresh.setAttribute('src', src);
    fresh.setAttribute('data-avlp-q', q);
    fresh.setAttribute('title', (t.map_title || 'Map') + ': ' + card.getAttribute('data-name'));
    iframe.parentNode.replaceChild(fresh, iframe);
    iframe = fresh;
   }
  }
  var cap = root.querySelector('.avlp__map-cap');
  if (cap) cap.textContent = card.getAttribute('data-name');
  if (scroll && iframe && window.matchMedia('(max-width: 989px)').matches) {
   var r = iframe.getBoundingClientRect();
   if (r.bottom < 60 || r.top > window.innerHeight - 60) {
    iframe.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
   }
  }
 }

 var INTERACTIVE = 'a, button, summary, details, input, select, textarea, label, [role="button"]';

 document.addEventListener('click', function (e) {
  var el = e.target && e.target.nodeType === 1 ? e.target : (e.target && e.target.parentElement);
  if (!el || !el.closest) return;
  var card = el.closest('.avlp-card');
  if (!card) return;
  var hit = el.closest(INTERACTIVE);
  if (hit && card.contains(hit) && hit !== card) return;
  selectCard(card.closest('[data-avlp]'), card, true);
 });

 document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
  var card = e.target;
  if (!card || !card.classList || !card.classList.contains('avlp-card')) return;
  e.preventDefault();
  selectCard(card.closest('[data-avlp]'), card, false);
 });

 function initPage(root) {
  if (root._avlpInit) return;
  root._avlpInit = true;
  var t = i18nFor(root);
  var list = root.querySelector('.avlp__list');
  var msg = root.querySelector('.avlp__geo-msg');
  var geoBtn = root.querySelector('[data-avlp-geo]');
  var first = root.querySelector('.avlp-card');
  var iframe = root.querySelector('.avlp__map iframe');
  if (first && iframe) iframe.setAttribute('data-avlp-q', first.getAttribute('data-map') || '');

  if (geoBtn) {
   if (!('geolocation' in navigator)) { geoBtn.hidden = true; return; }
   geoBtn.addEventListener('click', function () {
    geoBtn.disabled = true;
    if (msg) msg.textContent = t.locating || '';
    navigator.geolocation.getCurrentPosition(function (pos) {
     var lat = pos.coords.latitude, lng = pos.coords.longitude;
     var items = Array.prototype.slice.call(list.children);
     items.forEach(function (li) {
      var c = li.querySelector('.avlp-card');
      var clat = parseFloat(c.getAttribute('data-lat')), clng = parseFloat(c.getAttribute('data-lng'));
      li._d = (isNaN(clat) || isNaN(clng)) ? Infinity : haversineKm(lat, lng, clat, clng);
      var dist = c.querySelector('.avlp-card__dist');
      if (dist && li._d !== Infinity) {
       var km = li._d < 10 ? li._d.toFixed(1) : Math.round(li._d).toString();
       if (LANG === 'fr') km = km.replace('.', ',');
       dist.textContent = km + ' km';
       dist.hidden = false;
      }
     });
     items.sort(function (a, b) { return a._d - b._d; }).forEach(function (li) { list.appendChild(li); });
     var nearest = list.querySelector('.avlp-card');
     if (nearest) selectCard(root, nearest, false);
     if (msg) msg.textContent = t.sorted || '';
     geoBtn.disabled = false;
    }, function () {
     if (msg) msg.textContent = t.geo_error || '';
     geoBtn.disabled = false;
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
   });
  }
 }

 function initPages() {
  var roots = document.querySelectorAll('[data-avlp]');
  for (var i = 0; i < roots.length; i++) initPage(roots[i]);
 }

 function boot() {
  try { renderAll(document); } catch (e) {}
  initPages();
  setInterval(function () { try { renderAll(document); } catch (e) {} }, 60000);
 }

 document.addEventListener('shopify:section:load', function (e) {
  try { renderAll(e.target); } catch (err) {}
  initPages();
 });

 window.AvantiLocations = { open: openDrawer, close: closeDrawer, refresh: renderAll, select: selectCard };

 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
 else boot();
})();
